((app, ng) => {

    app.component("figAccountInfoButton",
        {
            template: `
                <md-button class="md-icon-button btn-fig" ng-click="$ctrl.openFigAccountInfo($event)">
                    <md-icon md-svg-src="/Images/Logos/fig-logo-icon.svg" aria-label="FIG Data"></md-icon>
                    <md-tooltip md-delay="500">FIG Marketing</md-tooltip>
                </md-button>
            `,
            controller: figAccountInfoButtonController,
            bindings: {
                arcPolicyGuid: "<"
            }
        });

    function figAccountInfoButtonController(modalService) {
        const $ctrl = this;

        const openFigAccountInfo = ($event) => {
            modalService.openFigAccountInfo($ctrl.arcPolicyGuid, $event);
        }

        ng.extend($ctrl,
            {
                openFigAccountInfo,
            });
    }

})(window.app, window.angular);